export const PPC_CLOSE = 'ppcclose';

export const PpcCloseEvent = {
    COMPLETE: 'didCompleteFlow',
    CANCEL: 'didCancelFlow',
};
